import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";

/**
 * Header FinanceiroContratosLista.
 * 
 */

type Props = {
  ddlCentroCusto?: DropDown[];
  ddlCliente?: DropDown[];
  selectedIdsCentroCusto?: number[];
  selectedIdsCliente?: number[];
  selectedStatus?: number[];
  dataInicioDe?: Date | null;
  dataInicioAte?: Date | null;
  descricao?: string | null;
  dataDe?: Date | null;
  dataAte?: Date | null;
  codigo?: number | null;

  onClearFilters: () => void;
  handleIdCentroCustoChange: (v: number[]) => void;
  handleIdClienteChange: (v: number[]) => void;
  handleDescricaoChange: (v: string) => void;
  handleDataRangeChange: (v: Date | null, x: Date | null) => void;
  handleCodigoChange: (v: string | null) => void;
  handleStatusChange: (v: number[]) => void;
  handleDataInicioRangeChange: (v: Date | null, x: Date | null) => void;
};


export const Header = ({
  ddlCentroCusto = [],
  ddlCliente = [],
  selectedIdsCentroCusto = [],
  selectedIdsCliente = [],
  selectedStatus = [],
  dataInicioDe,
  dataInicioAte,
  descricao,
  dataDe,
  dataAte,
  codigo,

  onClearFilters,
  handleIdCentroCustoChange,
  handleIdClienteChange,
  handleDescricaoChange,
  handleDataRangeChange,
  handleCodigoChange,
  handleStatusChange,
  handleDataInicioRangeChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  const statusOptions: DropDown[] = [
    { id: 0, title: "Em andamento" },
    { id: 1, title: "Finalizado" },
    { id: 2, title: "Cancelado" },
    { id: 3, title: "Paralisado" }
  ];


  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6 items-center justify-center">
        <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

          <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
            <div className="w-full">
              <DefaultMultiAutocomplete
                label="Centro de Custo"
                value={ddlCentroCusto.filter(x => selectedIdsCentroCusto?.includes(x.id))}
                options={ddlCentroCusto}
                getOptionLabel={x => x.title}
                getOptionKey={x => x.id}
                onChange={x => handleIdCentroCustoChange(x?.map(y => y.id) ?? [])}
              />
            </div>

            <div className="w-full">
              <DefaultInput
                name="descricao"
                label="Descrição"
                value={descricao ?? ""}
                onChangeValue={handleDescricaoChange}
              />
            </div>

            <div className="w-full">
              <DefaultInput
                name="codigo"
                label="Código"
                value={codigo?.toString() ?? ""}
                onChangeValue={handleCodigoChange}
              />
            </div>

            <div className="w-full">
              <DefaultMultiAutocomplete
                label="status"
                value={statusOptions.filter(option => selectedStatus.includes(option.id))}
                options={statusOptions}
                getOptionLabel={x => x.title}
                getOptionKey={x => x.id}
                onChange={x => handleStatusChange(x?.map(y => y.id) ?? [])}
              />
            </div>

          </div>

          {/* Linha 2 */}
          <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1">
            <div className="w-full">
              <DefaultMultiAutocomplete
                label="Cliente"
                value={ddlCliente.filter(x => selectedIdsCliente?.includes(x.id))}
                options={ddlCliente}
                getOptionLabel={x => x.title}
                getOptionKey={x => x.id}
                onChange={x => handleIdClienteChange(x?.map(y => y.id) ?? [])}
              />
            </div>

            <div className="w-full">
              <DefaultDateRangePickerInput
                label="Data início do contrato "
                dataDe={dataDe ?? null}
                dataAte={dataAte ?? null}
                onChange={(start, end) => handleDataRangeChange(start, end)}
              />
            </div>


          </div>

          {/* Botão limpar */}
          <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
            <div className="w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}
              >
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>
      </div>
    </CascateList>
  );
};